import React from "react";
import { ChatMode } from "../../../enums/ChatMode";
import Constants from "../../../constants/Constansts";


interface BotDisclaimerProps {
    chatMode: ChatMode;
}

const BotDisclaimer: React.FC<BotDisclaimerProps> = ({ chatMode }) => {
    if (chatMode === ChatMode.Intranet) {
        return (
            <span>
                {Constants.INTRANET_DISCLAIMER_PREFIX}
                <a
                    href={Constants.INTRANET_RULES_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#0078d4", textDecoration: "underline" }}
                >
                    {Constants.INTRANET_RULES_LINK_TEXT}
                </a>.
            </span>
        );
    } else if (chatMode === ChatMode.FinancePeerReview) {
        return <span>{Constants.PEER_BOT_DISCLAIMER}</span>;
    }
    return null;
};
export default BotDisclaimer;